module.exports = __webpack_public_path__ + "static/media/download_app@2x.85b03cc6.png";